import { render, staticRenderFns } from "./AfterJudgementWaiterListTab.vue?vue&type=template&id=baab125c&scoped=true&lang=pug"
import script from "./AfterJudgementWaiterListTab.vue?vue&type=script&lang=ts"
export * from "./AfterJudgementWaiterListTab.vue?vue&type=script&lang=ts"
import style0 from "./AfterJudgementWaiterListTab.vue?vue&type=style&index=0&id=baab125c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baab125c",
  null
  
)

export default component.exports